import { IMapMarker, IPunchMapData } from "../models"

//returns conslidated marker objects.
export function consolidateMarkers(records: IPunchMapData[]): IMapMarker[] {
    const mapMarkerSets = new MapMarkerSets()
    if (records) {
        for (const record of records) {
            mapMarkerSets.addRecord(record)
        }
    }
    return mapMarkerSets.getAsMarkers()
}

class MapMarkerSets {
    private _mapMarkerSets
    constructor() {
        this._mapMarkerSets = Array()
    }

    getAsMarkers() {
        const returnMarkers: IMapMarker[] = []

        for (const markerSet of this._mapMarkerSets) {
            returnMarkers.push(markerSet.getAsMarker())
        }

        return returnMarkers
    }

    addRecord(record: IPunchMapData) {
        let lat = record.Latitude
        let lng = record.Longitude
        let hasGPS = true

        //if we don't have record or location coordinates, don't add it.
        if (lat === 0 && lng === 0) {
            return
        }

        const marker = this.createMarkerFromRecord(record, lat, lng)

        if (this._mapMarkerSets.length === 0) {
            this._mapMarkerSets.push(new MapMarkerSet(marker, hasGPS))
        } else {
            for (const thisMarkerSet of this._mapMarkerSets) {
                if (thisMarkerSet.shouldConsolidate(marker)) {
                    thisMarkerSet.addChildMarker(marker, hasGPS)
                    return
                }
            }

            //didn't match with existing punch, create new master
            this._mapMarkerSets.push(new MapMarkerSet(marker, hasGPS))
        }
    }

    addLocation(location) {
        const marker = this.createMarkerFromLocation(location)
        this._mapMarkerSets.push(new MapMarkerSet(marker, true))
    }

    createMarkerFromRecord(record, lat, lng) {
        return {
            position: {
                lat: lat,
                lng: lng
            },
            record: record,
            showInfoWindow: false,
            key: record.Punch.Id,
            icon: "/assets/markers/punch-pin.png",
            stacked: false,
            recordCount: 1
        }
    }

    createMarkerFromLocation(location) {
        return {
            position: {
                lat: location.Address.Latitude,
                lng: location.Address.Longitude
            },
            location: location,
            showInfoWindow: false,
            key: location.Id,
            icon: "/assets/markers/location-pin.png",
            stacked: false,
            recordCount: 1
        }
    }
}

class MapMarkerSet {
    private CONSOLIDATE_MINIMUM_DISTANCE = 20
    private _markersAllHaveGPS
    private _parentMarker: IMapMarker
    constructor(parentMarker, hasGPS) {

        this._markersAllHaveGPS = hasGPS
        this._parentMarker = parentMarker
        this._parentMarker.childMarkers = Array()
    }

    getAsMarker() {
        return this._parentMarker
    }

    addChildMarker(marker, hasGPS) {
        this._markersAllHaveGPS = this._markersAllHaveGPS && hasGPS

        //We now have multiple, change the icon
        this._parentMarker.icon = this._markersAllHaveGPS ? "/assets/markers/stacked-punches.png" : "/assets/markers/stacked-punches-location.png"
        this._parentMarker.stacked = true
        this._parentMarker.recordCount++
        this._parentMarker.childMarkers.push(marker)
    }

    shouldConsolidate(marker) {
        return (
            google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(this._parentMarker.position.lat, this._parentMarker.position.lng),
                new google.maps.LatLng(marker.position.lat, marker.position.lng)
            ) < this.CONSOLIDATE_MINIMUM_DISTANCE
        )
    }
}
